import {
  CTE_PAPEL_POR_TOMADOR,
  CTE_ROTULOS_TOMADOR,
  CTE_UFS_SEM_TOMADOR_ISENTO,
  CTE_UNIDADES_CARGA,
} from '../../../../../constants/cte-sem-nota'
import { getTps } from '../../../../../services/localstorage/localstorage.service'
import {
  isCnpjValido,
  isCpfValido,
  normalizarCnpj,
  somenteDigitos,
} from '../../../../../services/util/documento.service'
import { round2, toNum } from '../ValoresFiscaisCte/valoresFiscaisCte.util'

export const ESTILO_BOTAO_PARTE = { minWidth: 150 }

export function parteVazia(origem = 'manual') {
  return {
    origem,
    company_id: null,
    client_id: null,
    tp_id: null,
    tipo_pessoa: 'PJ',
    cnpj_cpf: '',
    situacao_icms: 'contribuinte',
    inscricao_estadual: '',
    nome: '',
    telefone: '',
    logradouro: '',
    numero: '',
    bairro: '',
    uf: null, // { id, uf, name }
    city: null, // { id, name }
    cep: '',
  }
}

export function parteDoCadastro(dados, ufs) {
  const uf = ufs.find(item => item.id === dados.uf_id || item.uf === dados.uf) || null
  return {
    ...parteVazia(dados.origem),
    company_id: dados.company_id || null,
    client_id: dados.client_id || null,
    tp_id: dados.tp_id || null,
    tipo_pessoa: dados.tipo_pessoa || 'PJ',
    cnpj_cpf: dados.cnpj_cpf || '',
    situacao_icms: dados.situacao_icms || 'nao_contribuinte',
    inscricao_estadual: dados.inscricao_estadual || '',
    nome: String(dados.nome || '').slice(0, 60),
    telefone: dados.telefone || '',
    logradouro: dados.logradouro || '',
    numero: dados.numero || '',
    bairro: dados.bairro || '',
    uf,
    city: dados.city_id ? { id: dados.city_id, name: dados.city_name || '' } : null,
    cep: dados.cep || '',
  }
}

export function camposFaltantesDoCadastro(parte) {
  const faltantes = []
  if (!parte.nome) faltantes.push('razão social')
  if (parte.situacao_icms !== 'contribuinte') faltantes.push('Inscrição Estadual')
  if (!parte.logradouro || !parte.numero || !parte.bairro || !parte.city) faltantes.push('endereço')
  if (!parte.cep) faltantes.push('CEP')
  if (!parte.telefone) faltantes.push('telefone')
  return faltantes
}

export function validarParte(parte, titulo) {
  if (!parte) return `Informe os dados do ${titulo}`
  if (parte.origem === 'empresa' && !parte.company_id) return `${titulo}: selecione a Empresa`
  if (parte.origem === 'cliente' && !parte.client_id) return `${titulo}: selecione o Cliente`
  if (parte.origem === 'tp' && !parte.tp_id) return `${titulo}: selecione o Operador Logístico`
  if (parte.tipo_pessoa === 'PF' && !isCpfValido(parte.cnpj_cpf)) return `${titulo}: CPF inválido`
  if (parte.tipo_pessoa === 'PJ' && !isCnpjValido(parte.cnpj_cpf)) return `${titulo}: CNPJ inválido`

  const nome = String(parte.nome || '').trim()
  if (nome.length < 2 || nome.length > 60)
    return `${titulo}: o nome deve ter entre 2 e 60 caracteres`
  if (!parte.situacao_icms) return `${titulo}: informe a situação no ICMS`
  if (parte.situacao_icms === 'contribuinte') {
    const ie = somenteDigitos(parte.inscricao_estadual)
    if (ie.length < 2 || ie.length > 14)
      return `${titulo}: informe a Inscrição Estadual (2 a 14 dígitos)`
  }
  const telefone = somenteDigitos(parte.telefone)
  if (telefone && (telefone.length < 6 || telefone.length > 14)) {
    return `${titulo}: telefone deve ter entre 6 e 14 dígitos`
  }
  const logradouro = String(parte.logradouro || '').trim()
  if (logradouro.length < 2) return `${titulo}: informe o logradouro`
  if (!String(parte.numero || '').trim()) return `${titulo}: informe o número do endereço`
  if (String(parte.bairro || '').trim().length < 2) return `${titulo}: informe o bairro`
  if (!parte.uf) return `${titulo}: selecione a UF`
  if (!parte.city || !parte.city.id) return `${titulo}: selecione a cidade`
  if (somenteDigitos(parte.cep).length !== 8) return `${titulo}: CEP deve ter 8 dígitos`

  return null
}

export function montarPartePayload(parte) {
  return {
    origem: parte.origem,
    company_id: parte.company_id,
    client_id: parte.client_id,
    tp_id: parte.tp_id,
    tipo_pessoa: parte.tipo_pessoa,
    cnpj_cpf:
      parte.tipo_pessoa === 'PF' ? somenteDigitos(parte.cnpj_cpf) : normalizarCnpj(parte.cnpj_cpf),
    situacao_icms: parte.situacao_icms,
    inscricao_estadual:
      parte.situacao_icms === 'contribuinte' ? somenteDigitos(parte.inscricao_estadual) : null,
    nome: String(parte.nome).trim().slice(0, 60),
    telefone: somenteDigitos(parte.telefone) || null,
    logradouro: String(parte.logradouro).trim(),
    numero: String(parte.numero).trim(),
    bairro: String(parte.bairro).trim(),
    city_id: parte.city.id,
    cep: somenteDigitos(parte.cep),
  }
}

export function tpParaConsulta(selectedTp) {
  if (selectedTp) return selectedTp
  const tps = getTps(false)
  return tps.length ? tps[0].id : null
}

export function tpPadrao(selectedTp) {
  if (selectedTp) return selectedTp
  const tps = getTps(false)
  return tps.length === 1 ? tps[0].id : null
}

const raizCnpj = cnpj => {
  const normalizado = normalizarCnpj(cnpj)
  return normalizado.length === 14 ? normalizado.slice(0, 8) : null
}

export function parteTomadora(form) {
  if (form.tomador === '4') return form.tomadorOutros
  return form[CTE_PAPEL_POR_TOMADOR[form.tomador]] || null
}

export function opcoesTomadorEmissao(form, { permitirOutros = true } = {}) {
  const partes = [
    ['0', form.remetente],
    ['1', form.expedidor],
    ['2', form.recebedor],
    ['3', form.destinatario],
  ]
  const opcoes = partes
    .filter(([, parte]) => parte)
    .map(([tomador, parte]) => ({ value: tomador, papel: CTE_ROTULOS_TOMADOR[tomador], parte }))
  return permitirOutros ? [...opcoes, { value: '4', papel: 'Outros', parte: null }] : opcoes
}

export function avisoTomador746(form) {
  if (!['1', '2', '4'].includes(form.tomador)) return null
  const tomadora = parteTomadora(form)
  if (!tomadora || tomadora.situacao_icms !== 'contribuinte') return null
  const raiz = raizCnpj(tomadora.cnpj_cpf)
  if (!raiz) return null
  const raizes = [form.remetente, form.destinatario]
    .filter(Boolean)
    .map(parte => raizCnpj(parte.cnpj_cpf))
  if (raizes.includes(raiz)) return null
  return 'Tomador contribuinte do ICMS que não é o remetente nem o destinatário: se ele também emite CT-e (transportador), a SEFAZ exige tipo de serviço Subcontratação ou Redespacho e rejeita o CTe Normal (rejeição 746).'
}

const PAPEIS_PARTES = [
  ['Remetente', 'remetente'],
  ['Destinatário', 'destinatario'],
  ['Expedidor', 'expedidor'],
  ['Recebedor', 'recebedor'],
]

export function erroTomador(form) {
  const tomadora = parteTomadora(form)
  if (!tomadora) return 'Selecione o tomador do serviço entre as partes informadas'
  if (form.tomador === '4') {
    const erroParte = validarParte(form.tomadorOutros, 'Tomador Outros')
    if (erroParte) return erroParte
    const telefone = somenteDigitos(form.tomadorOutros.telefone)
    if (telefone.length < 6 || telefone.length > 14) {
      return 'Tomador Outros: informe o telefone com 6 a 14 dígitos'
    }
    const documento = normalizarCnpj(form.tomadorOutros.cnpj_cpf)
    const repetida = PAPEIS_PARTES.find(
      ([, papel]) => form[papel] && normalizarCnpj(form[papel].cnpj_cpf) === documento,
    )
    if (repetida) {
      return `O CNPJ/CPF informado em Outros é o do ${repetida[0]}: selecione a opção ${repetida[0]} como tomador (rejeição 799)`
    }
  }
  if (
    tomadora.situacao_icms === 'isento' &&
    tomadora.uf &&
    CTE_UFS_SEM_TOMADOR_ISENTO.includes(tomadora.uf.uf)
  ) {
    return `A UF ${tomadora.uf.uf} não aceita tomador isento de IE: use Contribuinte com IE ou Não contribuinte`
  }
  return null
}

export function montarPartesPayload(form) {
  return {
    remetente: montarPartePayload(form.remetente),
    destinatario: form.destinatario ? montarPartePayload(form.destinatario) : null,
    expedidor: form.expedidor ? montarPartePayload(form.expedidor) : null,
    recebedor: form.recebedor ? montarPartePayload(form.recebedor) : null,
    tomador: form.tomador,
    tomador_outros: form.tomador === '4' ? montarPartePayload(form.tomadorOutros) : null,
  }
}

export function descreverPrestacao(ufEmissor, ufInicio, ufFim) {
  if (!ufInicio || !ufFim) {
    return 'Início e fim vêm das cidades do expedidor (ou do remetente) e do recebedor (ou do destinatário); ajuste se necessário.'
  }
  const base =
    ufInicio === ufFim
      ? `Operação interna (${ufInicio} → ${ufFim}): CFOP iniciado em 5`
      : `Operação interestadual (${ufInicio} → ${ufFim}): CFOP iniciado em 6`
  if (ufEmissor && ufEmissor !== ufInicio) {
    return `${base}. A prestação inicia em ${ufInicio}, fora da UF do emissor (${ufEmissor}): CFOP 5932/6932 e ICMS devido a ${ufInicio} (situação 90 – ICMS devido a outra UF).`
  }
  return `${base}.`
}

export function cargaInicial() {
  return {
    valor_carga: null,
    produto_predominante: '',
    quantidade: null,
    unidade: CTE_UNIDADES_CARGA[0],
    tipo_medida: CTE_UNIDADES_CARGA[0].tipoMedidaPadrao,
  }
}

export function cargaDoCadastro(dados) {
  const unidade =
    CTE_UNIDADES_CARGA.find(item => item.value === dados.unidade) || CTE_UNIDADES_CARGA[0]
  return {
    valor_carga: dados.valor_carga,
    produto_predominante: dados.produto_predominante || '',
    quantidade: dados.quantidade,
    unidade,
    tipo_medida: dados.tipo_medida || unidade.tipoMedidaPadrao,
  }
}

export function erroCarga(carga) {
  if (!(toNum(carga.valor_carga) > 0)) return 'Informe o Valor da Carga'
  const produto = String(carga.produto_predominante || '').trim()
  if (!produto || produto.length > 60) return 'Informe o Produto Predominante (até 60 caracteres)'
  if (!(toNum(carga.quantidade) > 0)) return 'Informe a Quantidade da Carga'
  const tipoMedida = String(carga.tipo_medida || '').trim()
  if (!tipoMedida || tipoMedida.length > 20)
    return 'Informe o Tipo de Medida da carga (até 20 caracteres)'
  return null
}

export function montarCargaPayload(carga) {
  return {
    valor_carga: round2(toNum(carga.valor_carga)),
    produto_predominante: String(carga.produto_predominante).trim(),
    quantidade: toNum(carga.quantidade),
    unidade: carga.unidade.value,
    tipo_medida: String(carga.tipo_medida).trim(),
  }
}
